import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import SvgCash from '@/src/assets/svgs/collection/cash-circle.svg'
import SvgClock from '@/src/assets/svgs/collection/clock-circle.svg'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import '@/src/extensions/number'
import BaseLoading from '../../helpers/base-loading/base-loading'

interface Props {
    openProfile?(): void
    isProfile?: boolean
}

export default function BasicInfos(props: Props) {
    const { merchantDetailed: detailed, polling } = useMerchant()
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        if (window.innerWidth < window.innerHeight && !props.isProfile)
            setIsMobile(true)
    }, [])

    const isLoading = polling?.isLoading || detailed?.isLoading

    if (isLoading) {
        return (
            <div className={styles.container}>
                <BaseLoading>
                    <aside className={styles.loadingBasic} />
                </BaseLoading>
            </div>
        )
    }

    const minimumOrder = detailed?.model?.minimumOrder
    const estimatedDescription = detailed?.model?.deliveryConfiguration.deliveryTimming.estimatedTimming.estimatedDeliveryTimeDescription

    return (
        <div className={`${styles.container} ${props.isProfile ? styles.containerProfile : ''}`}>
            <div className={styles.item}>
                <div className={styles.itemSvg}>
                    <SvgClock />
                </div>
                <span className={`${styles.itemText} ${isMobile ? 'font-sm' : ''}`}>{estimatedDescription}</span>
            </div>
            {
                minimumOrder
                    ?
                    <>
                        <b>•</b>
                        <div className={styles.item}>
                            <div className={styles.itemSvg}>
                                <SvgCash />
                            </div>
                            <span className={`${styles.itemText} ${isMobile ? 'font-sm' : ''}`}>Mínimo <b>{minimumOrder.toLocalePrice()}</b></span>
                        </div>
                    </>
                    :
                    <></>
            }
            {
                props.openProfile
                    ?
                    <>
                        <b>•</b>
                        <div onClick={props.openProfile} className={styles.seeMore} style={!minimumOrder ? { display: 'block' } : {}}>
                            <span className={`${styles.seeMoreText} ${isMobile ? 'font-sm' : ''}`}>Ver mais</span>
                        </div>
                    </>
                    :
                    <></>
            }
        </div>
    )
}
